import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import './HomeTeam.css';
import { ROUTES } from '../../utils/routes';

const sliderSettings = {
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3500,
  speed: 650,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  pauseOnHover: true,
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 1 } },
  ],
};

export default function HomeTeam() {
  const sliderRef = useRef(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setTeamMembers(data.teams);
      })
      .catch((error) => {
        console.log(error);
      }).finally(() => {
        setLoading(false);
      });
  }, []);
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <section className="home-team-section section-pad" id="team">
      <div className="container">
        <div className="home-team-header" data-aos="fade-up">
          <span className="section-tag">Leadership Team</span>
          <h2 className="home-team-heading">Meet Our Team</h2>
          <p className="home-team-subtext">
            Experienced transformation leaders across SAP, AI, data platforms, cybersecurity, and enterprise delivery.
          </p>
        </div>

        <div className="home-team-slider-wrap" data-aos="fade-up" data-aos-delay="80">
          <Slider {...sliderSettings} ref={sliderRef} className="home-team-slider">
            {teamMembers.map((member) => (
              <div className="home-team-slide-item" key={member.id}>
                <article className="home-team-card">
                  <div className="home-team-avatar-wrap">
                    <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}/${member.folder_path}/${member.image}`} alt={member.name} className="home-team-avatar" />
                  </div>

                  <div className="home-team-card-body">
                    <h3>{member.name}</h3>
                    <h4>{member.designation}</h4>
                    <p>{member.home_page_description}</p>
                    <a href="/leadership" className="home-team-profile-link">
                      View Profile <i className="bi bi-arrow-right"></i>
                    </a>
                  </div>
                </article>
              </div>
            ))}
          </Slider>

          <div className="home-team-slider-controls">
            <button
              type="button"
              className="home-team-arrow home-team-arrow-prev"
              aria-label="Previous team member"
              onClick={() => sliderRef.current?.slickPrev()}
            >
              <i className="bi bi-arrow-left"></i>
            </button>
            <button
              type="button"
              className="home-team-arrow home-team-arrow-next"
              aria-label="Next team member"
              onClick={() => sliderRef.current?.slickNext()}
            >
              <i className="bi bi-arrow-right"></i>
            </button>
          </div>

          <div className="explore-leadership-button" data-aos="fade-up" data-aos-delay="100">
            <Link to={ROUTES.LEADERSHIP} className="btn-explore-leadership">
              Explore Leadership
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
